window.originFetch = fetch;
if (!customElements.get("apply-discount-code")) {
  customElements.define(
    "apply-discount-code",
    class ApplyDiscountCode extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector("[data-input-code]"),
          applyButton: this.querySelector("[data-apply-button]"),
          hintCode: this.querySelector("[data-hint-code]"),
        };
        this.cartItems = document.querySelectorAll("cart-items");

        this.initEvent();
      }

      initEvent() {
        this.elements.applyButton.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.elements.input.value.trim() === "") {
            for (const component of this.components) {
              component.elements.input.value = "";
            }
            this.elements.input.focus(); // Focus on the input field
            this.elements.input.setCustomValidity(""); // Reset any previous custom validity message
            this.elements.input.reportValidity(); // Trigger the browser's validation message
          } else {
            this.submit(this.elements.input.value);
          }
        });
        this.elements.input.addEventListener("input", () => {
          if (this.classList.contains("loading")) return false;
          const value = this.elements.input.value;
          for (const component of this.components) {
            if (component != this) component.elements.input.value = value;
            component.classList.remove("failed");
            component.elements.applyButton.classList.remove("failed");
            component.elements.hintCode.innerHTML = this.elements.input.value;
          }
        });
        this.elements.input.addEventListener("keydown", (e) => {
          if (e.keyCode === 13) {
            this.elements.applyButton.click();
          }
        });
      }

      async submit(code) {
        this.startLoading();
        const redirect = encodeURIComponent(`${Shopify.routes.root}cart`);
        return originFetch(
          `${Shopify.routes.root}discount/${code}?redirect=${redirect}`
        )
          .then((res) => {
            return res.text();
          })
          .then(async (res) => {
            const html = new DOMParser().parseFromString(res, "text/html");
            const discountElement = html.querySelector("apply-discount-code");
            const discounts = discountElement
              .getAttribute("data-discounts")
              .split(",")
              .map((v) => v.trim().toLowerCase());
            console.log("discounts", discounts, "code", code);
            const codeLowerCase = code.toLowerCase();
            if (discounts.includes(codeLowerCase)) {
              // 折扣码有效
              //   publish(PUB_SUB_EVENTS.cartReload);
              this.notifySuccess();
              for (const component of this.components) {
                component.elements.input.value = "";
              }
              ajaxCart?.load()
            } else {
              // 折扣码无效
              //   publish(PUB_SUB_EVENTS.cartReload);
              this.notifyFailed();
            }
          })
          .finally(() => {
            this.finishLoading();
          });
      }

      get components() {
        return document.querySelectorAll("apply-discount-code");
      }

      /** 应用成功通知 */
      notifySuccess() {
        for (const component of this.components) {
          component.classList.remove("failed");
          component.elements.applyButton.classList.remove("failed");
          component.classList.add("success");
          component.elements.applyButton.classList.add("success");
        }
        setTimeout(() => {
          for (const component of this.components) {
            component.classList.remove("success");
            component.elements.applyButton.classList.remove("success");
          }
        }, 3000);
      }

      /** 应用失败通知 */
      notifyFailed() {
        for (const component of this.components) {
          component.classList.add("failed");
          component.elements.applyButton.classList.add("failed");
        }
      }

      startLoading() {
        this.cartItems.forEach((items) => items.enableLoading());
        for (const component of this.components) {
          component.classList.add("loading");
          component.elements.input.setAttribute("disabled", "");
          component.elements.applyButton.classList.add("loading");
        }
      }

      finishLoading() {
        this.cartItems.forEach((items) => items.disableLoading());
        for (const component of this.components) {
          component.classList.remove("loading");
          component.elements.input.removeAttribute("disabled");
          component.elements.applyButton.classList.remove("loading");
        }
      }
    }
  );
}

if (!customElements.get("cart-discount-copy")) {
  customElements.define(
    "cart-discount-copy",
    class CartDiscountCopy extends HTMLElement {
      constructor() {
        super();
      }
      get code() {
        return this.dataset.code;
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          e.preventDefault();
          const code = this.code;
          if (!code) return;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code);
          }
          const input = this.closest(".ajaxcart__footer")?.querySelector(
            "[data-input-code]"
          );
          if (input) {
            input.value = code;
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
          this.classList.add("copied");
          setTimeout(() => {
            this.classList.remove("copied");
          }, 3000);
        });
      }
    }
  );
}
if (!customElements.get("upsell-action")) {
  customElements.define(
    "upsell-action",
    class UpsellAction extends HTMLElement {
      get id() {
        const selectedSwatch = this.closest(".ajaxcart-upsell-item")?.querySelector(
          "[data-upsell-variant-id][aria-pressed='true']"
        );
        return Number(
          selectedSwatch?.dataset.upsellVariantId ||
            this.closest(".ajaxcart-upsell-item")?.querySelector("select")?.value ||
            this.dataset.id
        );
      }
      get quantity() {
        return Number(this.querySelector("[data-upsell-quantity-value]")?.textContent) || 1;
      }
      connectedCallback() {
        if (this._isBound) return;
        this.atc = this.querySelector(".ajaxcart-upsell-item-atc");
        if (!this.atc) return;
        this._isBound = true;

        const item = this.closest(".ajaxcart-upsell-item");
        const select = item?.querySelector(".ajaxcart-upsell-item-variant-picker select");
        item?.querySelectorAll("[data-upsell-variant-id]").forEach((swatch) => {
          swatch.addEventListener("click", () => {
            item
              .querySelectorAll("[data-upsell-variant-id]")
              .forEach((button) => button.setAttribute("aria-pressed", "false"));
            swatch.setAttribute("aria-pressed", "true");
            if (select) select.value = swatch.dataset.upsellVariantId;

            const price = Number(swatch.dataset.price);
            const priceElement = item.querySelector(".ajaxcart-upsell-item-price");
            if (priceElement && Number.isFinite(price)) {
              priceElement.firstChild.textContent = `¥${Math.round(
                price / 100
              ).toLocaleString("ja-JP")}`;
            }
          });
        });

        const quantityValue = this.querySelector("[data-upsell-quantity-value]");
        const minusButton = this.querySelector("[data-upsell-quantity-minus]");
        const plusButton = this.querySelector("[data-upsell-quantity-plus]");
        const updateQuantity = (nextQuantity) => {
          const quantity = Math.max(1, Math.min(99, nextQuantity));
          if (quantityValue) quantityValue.textContent = quantity;
          if (minusButton) minusButton.disabled = quantity <= 1;
          if (plusButton) plusButton.disabled = quantity >= 99;
        };
        minusButton?.addEventListener("click", () =>
          updateQuantity(this.quantity - 1)
        );
        plusButton?.addEventListener("click", () =>
          updateQuantity(this.quantity + 1)
        );

        this.atc.addEventListener("click", (e) => {
          let formData = {
            items: [
              {
                id: this.id,
                quantity: this.quantity,
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              ajaxCart.load();
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
      }
    }
  );
}

const cartProductPageCache = new Map();

if (!customElements.get("cart-gift-products")) {
  customElements.define(
    "cart-gift-products",
    class CartGiftProducts extends HTMLElement {
      connectedCallback() {
        if (this._isBound) return;
        this._isBound = true;

        const sources = this.collectGiftSources();
        this.giftsPromise = sources.size
          ? this.loadGifts(sources)
          : Promise.resolve(new Map());
        this.bindCheckout();
      }

      collectGiftSources(selectedKeys) {
        const selected = selectedKeys ? new Set(selectedKeys) : null;
        const sources = new Map();
        this.querySelectorAll("[data-gift-source-url]").forEach((element) => {
          if (selected && !selected.has(element.dataset.key)) return;
          const productUrl = this.normalizeUrl(element.dataset.giftSourceUrl);
          if (!productUrl) return;
          const quantity =
            Number(element.dataset.giftSourceQuantity) || 1;
          sources.set(productUrl, (sources.get(productUrl) || 0) + quantity);
        });
        return sources;
      }

      normalizeUrl(value) {
        if (!value) return "";
        try {
          const url = new URL(value, window.location.origin);
          url.search = "";
          url.hash = "";
          return url.href;
        } catch (error) {
          return "";
        }
      }

      async fetchProductPage(productUrl) {
        if (!cartProductPageCache.has(productUrl)) {
          cartProductPageCache.set(
            productUrl,
            fetch(productUrl, {
              headers: { "X-Requested-With": "XMLHttpRequest" },
            }).then((response) => {
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.text();
            })
          );
        }
        return cartProductPageCache.get(productUrl);
      }

      async loadGifts(sources) {
        const sourceEntries = [...sources.entries()];
        const results = await Promise.allSettled(
          sourceEntries.map(([productUrl]) => this.fetchProductPage(productUrl))
        );
        if (!this.isConnected) return;

        const gifts = new Map();
        results.forEach((result, index) => {
          if (result.status !== "fulfilled") return;
          const quantity = sourceEntries[index][1];
          const html = new DOMParser().parseFromString(
            result.value,
            "text/html"
          );
          const sourceGiftUrls = new Set();

          html.querySelectorAll("[data-cart-gift]").forEach((giftElement) => {
            const productUrl = this.normalizeUrl(
              giftElement.dataset.giftProductUrl
            );
            const variantId = Number(giftElement.dataset.giftVariantId);
            const available = giftElement.dataset.giftAvailable !== "false";
            const customText = giftElement.querySelector(
              ".product-gift__text"
            )?.textContent;
            const giftQuantity = this.parseGiftQuantity(customText, quantity);
            if (
              !productUrl ||
              !Number.isInteger(variantId) ||
              variantId <= 0 ||
              !available ||
              sourceGiftUrls.has(productUrl)
            ) {
              return;
            }
            sourceGiftUrls.add(productUrl);

            const currentGift = gifts.get(variantId);
            if (currentGift) {
              currentGift.quantity += giftQuantity;
              return;
            }

            const image = giftElement.querySelector(
              ".product-gift__image img"
            );
            gifts.set(variantId, {
              productUrl,
              variantId,
              title: giftElement.dataset.giftTitle || "",
              price: Number(giftElement.dataset.giftPrice),
              quantity: giftQuantity,
              image: image?.getAttribute("src") || "",
              imageWidth: Number(image?.getAttribute("width")),
              imageHeight: Number(image?.getAttribute("height")),
            });
          });
        });

        this.gifts = gifts;
        if (!gifts.size) return gifts;

        const list = this.querySelector("[data-cart-gift-list]");
        if (!list) return gifts;
        const fragment = document.createDocumentFragment();
        gifts.forEach((gift) => fragment.appendChild(this.createGiftItem(gift)));
        list.replaceChildren(fragment);
        this.hidden = false;
        return gifts;
      }

      parseGiftQuantity(value, fallbackQuantity) {
        const normalizedValue = String(value || "").replace(
          /[０-９]/g,
          (digit) => String.fromCharCode(digit.charCodeAt(0) - 0xfee0)
        );
        const match = normalizedValue.match(/数量\s*[:：]\s*(\d+)\s*点/);
        if (!match) return Math.max(1, Number(fallbackQuantity) || 1);
        return Math.max(1, Math.min(99, Number(match[1]) || 1));
      }

      bindCheckout() {
        const form = this.closest("form.ajaxcart");
        if (!form) return;

        form.addEventListener("submit", async (event) => {
          if (event.submitter && event.submitter.name !== "checkout") return;
          if (this._isCheckingOut) {
            event.preventDefault();
            return;
          }

          event.preventDefault();

          const selection = document.querySelector("cart-line-selection");
          const selectedKeys = selection ? selection.selectedKeys : null;
          if (selectedKeys && selectedKeys.length === 0) {
            window.alert("商品を選択してください");
            return;
          }

          this._isCheckingOut = true;
          const checkoutButton = form.querySelector(
            "button[name='checkout']"
          );
          if (checkoutButton) {
            checkoutButton.disabled = true;
            checkoutButton.setAttribute("aria-busy", "true");
          }

          try {
            if (
              selectedKeys &&
              selection &&
              selectedKeys.length !== selection.lines.length &&
              typeof window.parkUnselectedCartItems === "function"
            ) {
              await window.parkUnselectedCartItems(selectedKeys);
            }

            const gifts = selectedKeys
              ? await this.loadGifts(this.collectGiftSources(selectedKeys))
              : await this.giftsPromise;
            await this.syncGifts(gifts || new Map());
          } catch (error) {
            console.error("Unable to sync cart gifts before checkout:", error);
            try {
              if (typeof window.restoreDeferredCartItems === "function") {
                await window.restoreDeferredCartItems();
              }
            } catch (restoreError) {
              console.error(
                "Unable to restore parked cart items:",
                restoreError
              );
            }
            this._isCheckingOut = false;
            if (checkoutButton) {
              checkoutButton.disabled = false;
              checkoutButton.removeAttribute("aria-busy");
            }
            return;
          }

          window.location.assign(
            `${window.Shopify?.routes?.root || "/"}checkout`
          );
        });
      }

      async syncGifts(gifts) {
        const root = window.Shopify?.routes?.root || "/";
        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: "application/json" },
        });
        if (!cartResponse.ok) {
          throw new Error(`Cart request failed: HTTP ${cartResponse.status}`);
        }

        const cart = await cartResponse.json();
        const manualQuantities = new Map();
        const automaticGiftLines = new Map();
        cart.items.forEach((item) => {
          const variantId = Number(item.variant_id || item.id);
          const isAutomaticGift =
            item.properties?._dreame_auto_gift === "true";
          if (isAutomaticGift) {
            const lines = automaticGiftLines.get(variantId) || [];
            lines.push(item);
            automaticGiftLines.set(variantId, lines);
          } else {
            manualQuantities.set(
              variantId,
              (manualQuantities.get(variantId) || 0) +
                Number(item.quantity || 0)
            );
          }
        });

        const updates = {};
        const items = [];
        gifts.forEach((gift) => {
          const requiredAutomaticQuantity = Math.max(
            0,
            gift.quantity - (manualQuantities.get(gift.variantId) || 0)
          );
          const existingLines = automaticGiftLines.get(gift.variantId) || [];

          if (existingLines.length) {
            existingLines.forEach((line, index) => {
              const nextQuantity =
                index === 0 ? requiredAutomaticQuantity : 0;
              if (Number(line.quantity) !== nextQuantity) {
                updates[line.key] = nextQuantity;
              }
            });
            automaticGiftLines.delete(gift.variantId);
          } else if (requiredAutomaticQuantity > 0) {
            items.push({
              id: gift.variantId,
              quantity: requiredAutomaticQuantity,
              properties: {
                _dreame_auto_gift: "true",
              },
            });
          }
        });

        automaticGiftLines.forEach((lines) => {
          lines.forEach((line) => {
            updates[line.key] = 0;
          });
        });

        if (Object.keys(updates).length) {
          const updateResponse = await fetch(`${root}cart/update.js`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          });
          if (!updateResponse.ok) {
            const error = await updateResponse.text();
            throw new Error(
              `Gift update request failed: HTTP ${updateResponse.status} ${error}`
            );
          }
        }

        if (!items.length) return;
        const addResponse = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items }),
        });
        if (!addResponse.ok) {
          const error = await addResponse.text();
          throw new Error(
            `Gift add request failed: HTTP ${addResponse.status} ${error}`
          );
        }
      }

      createGiftItem(gift) {
        const item = document.createElement("article");
        item.className = "ajaxcart-gift-item";

        const imageWrap = document.createElement("div");
        imageWrap.className = "ajaxcart-gift-item__image";
        if (gift.image) {
          const image = document.createElement("img");
          image.src = gift.image;
          image.alt = gift.title;
          image.loading = "lazy";
          if (gift.imageWidth) image.width = gift.imageWidth;
          if (gift.imageHeight) image.height = gift.imageHeight;
          imageWrap.appendChild(image);
        }

        const title = document.createElement("h4");
        title.className = "ajaxcart-gift-item__title";
        title.textContent = gift.title;

        const meta = document.createElement("div");
        meta.className = "ajaxcart-gift-item__meta";
        const free = document.createElement("span");
        free.className = "ajaxcart-gift-item__free";
        free.textContent = "無料";
        const comparePrice = document.createElement("del");
        comparePrice.className = "ajaxcart-gift-item__compare-price";
        comparePrice.textContent = Number.isFinite(gift.price)
          ? `${Math.round(gift.price / 100).toLocaleString("ja-JP")}円`
          : "";
        const quantity = document.createElement("span");
        quantity.className = "ajaxcart-gift-item__quantity";
        quantity.textContent = `数量: ${gift.quantity}点`;
        meta.append(free, comparePrice, quantity);

        item.append(imageWrap, title, meta);
        return item;
      }
    }
  );
}

if (!customElements.get("cart-upsell-products")) {
  const upsellProductCache = new Map();

  customElements.define(
    "cart-upsell-products",
    class CartUpsellProducts extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector("[data-upsell-list]");
        if (!this.list) return;

        const productUrls = Array.from(
          this.querySelectorAll("[data-cart-product-url]")
        )
          .map((element) => this.normalizeUrl(element.dataset.cartProductUrl))
          .filter(Boolean);

        if (!productUrls.length) return;
        this.loadProductAccessories([...new Set(productUrls)]);
      }

      normalizeUrl(value) {
        if (!value) return "";
        try {
          const url = new URL(value, window.location.origin);
          url.search = "";
          url.hash = "";
          return url.href;
        } catch (error) {
          return "";
        }
      }

      async fetchProductPage(productUrl) {
        if (!cartProductPageCache.has(productUrl)) {
          cartProductPageCache.set(
            productUrl,
            fetch(productUrl, {
              headers: { "X-Requested-With": "XMLHttpRequest" },
            }).then((response) => {
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.text();
            })
          );
        }

        const responseText = await cartProductPageCache.get(productUrl);
        const html = new DOMParser().parseFromString(responseText, "text/html");

        return Array.from(
          html.querySelectorAll(
            ".product-accessories__item[data-product-url]:not(.sold-out)"
          )
        ).map((item) => ({
          productUrl: this.normalizeUrl(item.dataset.productUrl),
          variantId: Number(item.dataset.id),
          title:
            item.querySelector(".accessories-title")?.textContent.trim() || "",
          image:
            item.querySelector(".accessories-image img")?.getAttribute("src") ||
            "",
          imageWidth: Number(
            item.querySelector(".accessories-image img")?.getAttribute("width")
          ),
          imageHeight: Number(
            item.querySelector(".accessories-image img")?.getAttribute("height")
          ),
          price: Number(item.dataset.price),
        }));
      }

      async fetchProductData(productUrl) {
        const url = new URL(productUrl);
        url.pathname = `${url.pathname.replace(/\/$/, "")}.js`;

        if (!upsellProductCache.has(url.href)) {
          upsellProductCache.set(
            url.href,
            fetch(url.href, {
              headers: { Accept: "application/json" },
            }).then((response) => {
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              return response.json();
            })
          );
        }

        return upsellProductCache.get(url.href);
      }

      async getColorVariants(productUrl) {
        try {
          const product = await this.fetchProductData(productUrl);
          const options = Array.isArray(product.options) ? product.options : [];
          const colorIndex = options.findIndex((option) => {
            const name = String(option?.name || option).toLowerCase();
            return (
              name.includes("color") ||
              name.includes("colour") ||
              name.includes("カラー") ||
              name.includes("色")
            );
          });

          if (colorIndex < 0) return [];

          const colorVariants = [];
          const usedColors = new Set();
          product.variants.forEach((variant) => {
            if (!variant.available) return;
            const color =
              variant.options?.[colorIndex] ||
              variant[`option${colorIndex + 1}`];
            if (!color || usedColors.has(color)) return;
            usedColors.add(color);
            colorVariants.push({
              id: variant.id,
              color,
              price: variant.price,
            });
          });

          return colorVariants.length > 1 ? colorVariants : [];
        } catch (error) {
          return [];
        }
      }

      async loadProductAccessories(cartProductUrls) {
        const results = await Promise.allSettled(
          cartProductUrls.map((url) => this.fetchProductPage(url))
        );
        if (!this.isConnected) return;

        const cartProducts = new Set(cartProductUrls);
        const seenProducts = new Set();
        const accessories = [];

        results.forEach((result) => {
          if (result.status !== "fulfilled") return;
          result.value.forEach((accessory) => {
            if (
              !accessory.productUrl ||
              cartProducts.has(accessory.productUrl) ||
              seenProducts.has(accessory.productUrl)
            ) {
              return;
            }
            seenProducts.add(accessory.productUrl);
            accessories.push(accessory);
          });
        });

        if (!accessories.length) return;

        const enrichedAccessories = await Promise.all(
          accessories.map(async (accessory) => ({
            ...accessory,
            colorVariants: await this.getColorVariants(accessory.productUrl),
          }))
        );
        if (!this.isConnected) return;

        const fragment = document.createDocumentFragment();
        enrichedAccessories.forEach((accessory) => {
          fragment.appendChild(this.createUpsellItem(accessory));
        });
        this.list.replaceChildren(fragment);
      }

      createUpsellItem(accessory) {
        const item = document.createElement("div");
        item.className = "ajaxcart-upsell-item";
        item.dataset.productUrl = accessory.productUrl;

        const imageWrap = document.createElement("div");
        imageWrap.className = "ajaxcart-upsell-item-image";
        if (accessory.image) {
          const image = document.createElement("img");
          image.src = accessory.image;
          image.alt = accessory.title;
          image.loading = "lazy";
          if (accessory.imageWidth) image.width = accessory.imageWidth;
          if (accessory.imageHeight) image.height = accessory.imageHeight;
          imageWrap.appendChild(image);
        }

        const textWrap = document.createElement("div");
        textWrap.className = "ajaxcart-upsell-item-text";

        const title = document.createElement("div");
        title.className = "ajaxcart-upsell-item-title";
        title.textContent = accessory.title;

        const price = document.createElement("div");
        price.className = "ajaxcart-upsell-item-price";
        price.append(
          document.createTextNode(
            Number.isFinite(accessory.price)
              ? `¥${Math.round(accessory.price / 100).toLocaleString("ja-JP")}`
              : ""
          )
        );
        const tax = document.createElement("span");
        tax.className = "ajaxcart-upsell-item-tax";
        tax.textContent = "(税込)";
        price.appendChild(tax);

        const action = document.createElement("upsell-action");
        action.className = "ajaxcart-upsell-item-action";
        action.dataset.id =
          accessory.colorVariants[0]?.id || accessory.variantId;

        if (accessory.colorVariants.length) {
          const picker = document.createElement("div");
          picker.className = "ajaxcart-upsell-item-variant-picker";
          picker.setAttribute("aria-label", "カラー");
          const select = document.createElement("select");
          select.className = "visually-hidden";
          select.tabIndex = -1;
          select.setAttribute("aria-hidden", "true");

          const swatches = document.createElement("div");
          swatches.className = "ajaxcart-upsell-swatches";
          accessory.colorVariants.forEach((variant, index) => {
            const option = document.createElement("option");
            option.value = variant.id;
            option.textContent = variant.color;
            select.appendChild(option);

            const swatch = document.createElement("button");
            swatch.type = "button";
            swatch.className = "ajaxcart-upsell-swatch";
            swatch.dataset.upsellVariantId = variant.id;
            swatch.dataset.price = variant.price;
            swatch.dataset.colorName = variant.color;
            swatch.setAttribute("aria-label", variant.color);
            swatch.setAttribute("aria-pressed", index === 0 ? "true" : "false");
            swatch.style.setProperty(
              "--upsell-swatch-color",
              this.getSwatchColor(variant.color)
            );
            swatch.appendChild(document.createElement("span"));
            swatches.appendChild(swatch);
          });
          picker.append(select, swatches);
          textWrap.appendChild(picker);
        }

        const addButton = document.createElement("button");
        addButton.type = "button";
        addButton.className = "ajaxcart-upsell-item-atc";
        addButton.textContent = "カートに追加";

        const quantity = document.createElement("div");
        quantity.className = "ajaxcart-upsell-quantity";
        quantity.innerHTML = `
          <span class="ajaxcart-upsell-quantity__label">数量:</span>
          <div class="ajaxcart-upsell-quantity__control">
            <button type="button" class="ajaxcart-upsell-quantity__button" data-upsell-quantity-minus aria-label="数量を減らす" disabled>−</button>
            <span class="ajaxcart-upsell-quantity__value" data-upsell-quantity-value aria-live="polite">1</span>
            <button type="button" class="ajaxcart-upsell-quantity__button" data-upsell-quantity-plus aria-label="数量を増やす">+</button>
          </div>
        `;

        action.append(addButton, quantity);
        textWrap.prepend(title, price);
        item.append(imageWrap, textWrap, action);

        return item;
      }

      getSwatchColor(colorName) {
        const color = String(colorName).toLowerCase();
        if (color.includes("ホワイト") || color.includes("白") || color.includes("white")) return "#f4f4f4";
        if (color.includes("ブラック") || color.includes("黒") || color.includes("black")) return "#171717";
        if (color.includes("グレー") || color.includes("灰") || color.includes("gray") || color.includes("grey")) return "#999";
        if (color.includes("ピンク") || color.includes("pink")) return "#e8b8bd";
        if (color.includes("ゴールド") || color.includes("gold")) return "#c4a27e";
        if (color.includes("シルバー") || color.includes("silver")) return "#c7c7c7";
        if (color.includes("ブルー") || color.includes("青") || color.includes("blue")) return "#7396bd";
        if (color.includes("レッド") || color.includes("赤") || color.includes("red")) return "#b84a4a";
        return "#d9d9d9";
      }
    }
  );
}

if (!customElements.get("cart-line-selection")) {
  // The drawer is re-rendered on every cart change, so selection lives here.
  const selectedCartLines = new Map();
  const DEFERRED_CART_STORAGE_KEY = "dreameDeferredCartItems";
  const cartRoutesRoot = () => window.Shopify?.routes?.root || "/";

  const formatCartMoney = (amount) => {
    if (window.theme?.Currency?.formatMoney) {
      return theme.Currency.formatMoney(
        amount,
        theme.moneyFormat || theme.strings?.moneyFormat
      );
    }
    return `¥${Number(amount || 0).toLocaleString("ja-JP")}`;
  };

  const parkUnselectedCartItems = async (selectedKeys) => {
    const selected = new Set(selectedKeys);
    const cartResponse = await fetch(`${cartRoutesRoot()}cart.js`, {
      headers: { Accept: "application/json" },
    });
    if (!cartResponse.ok) {
      throw new Error(`Cart request failed: HTTP ${cartResponse.status}`);
    }

    const cart = await cartResponse.json();
    const deferred = [];
    const updates = {};

    cart.items.forEach((item) => {
      if (item.properties?._dreame_auto_gift === "true") return;
      if (selected.has(item.key)) return;

      const payload = {
        id: Number(item.variant_id || item.id),
        quantity: Number(item.quantity || 0),
      };
      if (item.properties && Object.keys(item.properties).length) {
        payload.properties = item.properties;
      }
      const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (sellingPlanId) payload.selling_plan = sellingPlanId;
      deferred.push(payload);
      updates[item.key] = 0;
    });

    if (!deferred.length) return;

    const updateResponse = await fetch(`${cartRoutesRoot()}cart/update.js`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });
    if (!updateResponse.ok) {
      throw new Error(
        `Selected checkout update failed: HTTP ${updateResponse.status}`
      );
    }

    sessionStorage.setItem(
      DEFERRED_CART_STORAGE_KEY,
      JSON.stringify(deferred)
    );
  };

  const restoreDeferredCartItems = async () => {
    let deferred = [];
    try {
      deferred = JSON.parse(
        sessionStorage.getItem(DEFERRED_CART_STORAGE_KEY) || "[]"
      );
    } catch (error) {
      deferred = [];
    }
    if (!Array.isArray(deferred) || !deferred.length) return;

    sessionStorage.removeItem(DEFERRED_CART_STORAGE_KEY);
    const items = deferred.filter((item) => item.id && item.quantity > 0);
    if (!items.length) return;

    const addResponse = await fetch(`${cartRoutesRoot()}cart/add.js`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    });
    if (!addResponse.ok) {
      sessionStorage.setItem(
        DEFERRED_CART_STORAGE_KEY,
        JSON.stringify(deferred)
      );
      throw new Error(
        `Deferred cart restore failed: HTTP ${addResponse.status}`
      );
    }
    if (window.ajaxCart) ajaxCart.load();
  };

  document.addEventListener("DOMContentLoaded", () => {
    restoreDeferredCartItems().catch((error) => {
      console.error("Unable to restore parked cart items:", error);
    });
  });
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    restoreDeferredCartItems().catch((error) => {
      console.error("Unable to restore parked cart items:", error);
    });
  });

  customElements.define(
    "cart-line-selection",
    class CartLineSelection extends HTMLElement {
      connectedCallback() {
        if (this._isBound) return;
        this._isBound = true;
        this.selectAll = this.querySelector("[data-select-all]");
        this.counter = this.querySelector("[data-selected-count]");
        this.checkoutButton = this.closest("form")?.querySelector(
          "button[name='checkout']"
        );

        this.addEventListener("change", (event) => {
          if (event.target === this.selectAll) {
            this.lines.forEach((line) => {
              line.checked = this.selectAll.checked;
            });
          } else if (!event.target.matches("[data-line-select]")) {
            return;
          }
          this.sync();
        });

        this.lines.forEach((line) => {
          const stored = selectedCartLines.get(line.dataset.key);
          line.checked = stored === undefined ? true : stored;
        });
        this.disableMinusAtOne();
        this.sync();
      }

      get lines() {
        return Array.from(this.querySelectorAll("[data-line-select]"));
      }

      get selectedKeys() {
        return this.lines
          .filter((line) => line.checked)
          .map((line) => line.dataset.key)
          .filter(Boolean);
      }

      disableMinusAtOne() {
        this.querySelectorAll(".ajaxcart__row").forEach((row) => {
          const input = row.querySelector(".ajaxcart__qty-num");
          const minus = row.querySelector(".ajaxcart__qty--minus");
          if (input && minus) minus.disabled = Number(input.value) <= 1;
        });
      }

      sync() {
        const lines = this.lines;
        const selected = lines.filter((line) => line.checked);

        selectedCartLines.clear();
        lines.forEach((line) =>
          selectedCartLines.set(line.dataset.key, line.checked)
        );

        if (this.selectAll) {
          this.selectAll.checked =
            lines.length > 0 && selected.length === lines.length;
          this.selectAll.indeterminate =
            selected.length > 0 && selected.length < lines.length;
        }
        if (this.counter) this.counter.textContent = `${selected.length} 選択`;

        const selectedTotal = selected.reduce((sum, line) => {
          const row = line.closest("[data-line-price]");
          return sum + (Number(row?.dataset.linePrice) || 0);
        }, 0);
        this.closest("form")
          ?.querySelectorAll("[data-selected-money]")
          .forEach((element) => {
            element.textContent = formatCartMoney(selectedTotal);
          });

        if (this.checkoutButton) {
          this.checkoutButton.disabled = selected.length === 0;
        }
      }
    }
  );

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-cart-remove]");
    if (!button || button.disabled) return;

    const line = Number(button.dataset.line);
    if (!line) return;

    button.disabled = true;
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 }),
    })
      .then(() => {
        if (window.ajaxCart) ajaxCart.load();
      })
      .catch((error) => {
        console.error("Error:", error);
        button.disabled = false;
      });
  });

  window.parkUnselectedCartItems = parkUnselectedCartItems;
  window.restoreDeferredCartItems = restoreDeferredCartItems;
}

if (!customElements.get("help-icon")) {
  customElements.define(
    "help-icon",
    class HelpIcon extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.modalOverlay = document.getElementById("modalOverlay");
        this.closeBtn = document.getElementById("closeBtn");
        this.addEventListener("click", () => {
          modalOverlay.classList.add("active");
        });
        this.closeBtn.addEventListener("click", () => {
          this.modalOverlay.classList.remove("active");
        });
        this.modalOverlay.addEventListener("click", (e) => {
          if (e.target === this.modalOverlay) {
            this.modalOverlay.classList.remove("active");
          }
        });
        document.addEventListener("keydown", function (e) {
          if (
            e.key === "Escape" &&
            this.modalOverlay.classList.contains("active")
          ) {
            this.modalOverlay.classList.remove("active");
          }
        });
      }
    }
  );
}
// // 获取DOM元素
// const helpIcon = document.getElementById("helpIcon");
// const modalOverlay = document.getElementById("modalOverlay");
// const closeBtn = document.getElementById("closeBtn");

// // 点击问号图标打开弹窗
// helpIcon.addEventListener("click", function () {
//   modalOverlay.classList.add("active");
// });

// // 点击关闭按钮关闭弹窗
// closeBtn.addEventListener("click", function () {
//   modalOverlay.classList.remove("active");
// });

// // 点击弹窗外部区域关闭弹窗
// modalOverlay.addEventListener("click", function (e) {
//   if (e.target === modalOverlay) {
//     modalOverlay.classList.remove("active");
//   }
// });

// // 按ESC键关闭弹窗
// document.addEventListener("keydown", function (e) {
//   if (e.key === "Escape" && modalOverlay.classList.contains("active")) {
//     modalOverlay.classList.remove("active");
//   }
// });
